import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { Spinner } from "../Spinner/spinner.component";

type PaginationComponentProps = {
    statusText: string;
    currentNumberOfHits: number;
    totalNumberOfHits: number;
    hitsToLoad: number;
    loading: boolean;
    onClick: () => void;
    className?: string;
};

const PaginationComponent = ({
    statusText,
    currentNumberOfHits,
    totalNumberOfHits,
    hitsToLoad,
    loading,
    onClick,
    className
}: PaginationComponentProps) => {
    const { t } = useGranite();

    return (
        <section className={cn("tw:flex tw:flex-col", className)}>
            <div
                className={cn(
                    "tw:flex tw:flex-col tw:text-center tw:self-center tw:relative"
                )}
            >
                <span
                    className={cn("tw:mb-2")}
                    dangerouslySetInnerHTML={{ __html: statusText }}
                />
                <progress
                    className={cn(
                        "tw:w-full tw:border-none tw:h-1 tw:rounded-xs",
                        "tw:text-primary tw:bg-grey-light",
                        "tw:[&::-webkit-progress-bar]:bg-grey-light tw:[&::-webkit-progress-value]:bg-primary tw:[&::-moz-progress-bar]:bg-primary"
                    )}
                    max={totalNumberOfHits}
                    value={currentNumberOfHits}
                    aria-valuemin={0}
                    aria-valuemax={totalNumberOfHits}
                    aria-valuenow={currentNumberOfHits}
                />
                {currentNumberOfHits < totalNumberOfHits && (
                    <Button
                        className={cn("tw:mt-2")}
                        type="button"
                        onClick={onClick}
                        color={"gray"}
                        fullWidth={true}
                    >
                        {loading && <Spinner size={"sm"} />}
                        {!loading &&
                            t("search.pagination.loadMore", hitsToLoad)}
                    </Button>
                )}
            </div>
        </section>
    );
};

export { PaginationComponent };
